"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_TREE_NODE_WITH_ONE_CHILD_LEVEL = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_TREE_NODE_WITH_ONE_CHILD_LEVEL = (0, gql_1.gql)(`
  query productTreeNodeWithChildren($nodeId: ID!, $catalogId: ID!) {
    productTreeNode(id: $nodeId) {
      id
      children {
        ...ProductTreeNodeFragment
          ...@defer {
            productPresentationsNew(catalog: $catalogId) {
              totalCount
            }
        }
      }
    }
  }
`);
